<template>
  <div class="legend__wrapper">
    <ColorLegend
      v-for="color in colorKeys"
      :key="color"
      :attackType="color"
      :bgColor="colors[color]"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ColorLegend from './ColorLegend';

export default {
  name: 'Legend',
  components: { ColorLegend },
  computed: {
    ...mapState({ colors: state => state.curveColors }),
    colorKeys() {
      return Object.keys(this.colors);
    }
  }
};
</script>

<style lang="scss" scoped>
.legend__wrapper {
  display: flex;
  justify-content: center;
}
</style>
